import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  'inline-flex items-center rounded-[1em] border px-[0.75em] h-[1.8em] text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        dotted: 'gap-[0.4em] bg-transparent uppercase',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export const badgeDotVariants = cva(
  'badge-dot size-[0.85em] rounded-[35%] shrink-0',
);
